import API, { defaultHeaders } from '../';

const register = async (payload = {}) => {
  const headers = Object.assign({}, defaultHeaders);
  return fetch(`${API}/invitation/register-user/${payload.invitationCode}`, {
    method: 'put',
    headers,
    body: JSON.stringify(payload),
  });
};

export default register;
